import React from "react";
import { Link } from "react-router-dom";

const ORDER = ["en", "es", "nl", "fr"];

/**
 * ContentLangSwitcher — the discreet "EN · ES" switcher shown on a
 * publication that has linked localized versions. The API only ever
 * sends published siblings, so drafts are never exposed and languages
 * without a version are never shown.
 */
export default function ContentLangSwitcher({ item, basePath }) {
    const versions = (item && item.localized_versions) || [];
    if (!versions.length) return null;

    const all = [
        { language: item.language || "en", slug: item.slug, current: true },
        ...versions.map((v) => ({ ...v, current: false })),
    ].sort((a, b) => ORDER.indexOf(a.language) - ORDER.indexOf(b.language));

    return (
        <nav
            aria-label="Language versions"
            data-testid="content-lang-switcher"
            className="mt-6 flex items-center gap-1 font-display text-[15px] tracking-[0.02em]"
        >
            {all.map((v, i) => (
                <React.Fragment key={v.language}>
                    {v.current ? (
                        <span
                            aria-current="true"
                            data-testid={`content-lang-current-${v.language}`}
                            className="px-1.5 py-1 text-[color:var(--navy)] italic"
                        >
                            {v.language.toUpperCase()}
                        </span>
                    ) : (
                        <Link
                            to={`/${basePath}/${v.slug}`}
                            data-testid={`content-lang-link-${v.language}`}
                            aria-label={`Read this publication in ${v.language.toUpperCase()}`}
                            className="px-1.5 py-1 text-[color:var(--navy)]/55 hover:text-[color:var(--navy)] transition-colors duration-500"
                        >
                            {v.language.toUpperCase()}
                        </Link>
                    )}
                    {i < all.length - 1 && (
                        <span className="text-[color:var(--line-strong)]" aria-hidden>·</span>
                    )}
                </React.Fragment>
            ))}
        </nav>
    );
}
